<template>
  <div id="app">
    <app-header></app-header>
    <main class="app-main">
      <transition :name="transitionName" mode="out-in">
        <router-view />
      </transition>
    </main>
    <app-footer></app-footer>
    <message></message>
    <confirm></confirm>
    <app-loading></app-loading>
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader';
import AppFooter from '@/components/layout/AppFooter';
import Message from '@/components/layout/Message';
import Confirm from '@/components/util/Confirm';
import AppLoading from '@/components/plugins/loading/AppLoading';

export default {
  name: 'app',
  data () {
    return {
      transitionName: ''
    };
  },
  components: {
    AppHeader,
    AppFooter,
    Message,
    Confirm,
    AppLoading
  },
  watch: {
    '$route' (to, from) {
      this.transitionName = 'fade';
    }
  }
};
</script>

<style lang="scss">
@import './assets/scss/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue